import { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import Dropdown from '@components/form/Dropdown.component';

interface NewDatasetModalProps {
    show: boolean;
    onClose: () => void;
    onCreateDataset: (type: 'semantic' | 'datamart', name?: string) => void;
}

const DATASET_OPTIONS = [
    { value: 'semantic', label: 'Use Semantic Layer (Metrics & Dimensions)' },
    { value: 'datamart', label: 'Create Ad-hoc Data Mart' }
];

const NewDatasetModal = ({ show, onClose, onCreateDataset }: NewDatasetModalProps) => {
    const [selectedType, setSelectedType] = useState<'semantic' | 'datamart' | ''>('');
    const [datasetName, setDatasetName] = useState('');

    const handleCreate = () => {
        onCreateDataset(selectedType as 'semantic' | 'datamart', selectedType === 'datamart' ? datasetName : undefined);
        setSelectedType('');
        setDatasetName('');
    };

    const handleClose = () => {
        setSelectedType('');
        setDatasetName('');
        onClose();
    };

    const isCreateDisabled = !selectedType || (selectedType === 'datamart' && !datasetName.trim());

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create Dataset</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>How would you like to create your dataset?</Form.Label>
                    <Dropdown
                        options={DATASET_OPTIONS}
                        selected={selectedType}
                        onChange={(value) => {
                            setSelectedType(value as 'semantic' | 'datamart');
                            if (value === 'semantic') setDatasetName('');
                        }}
                    />
                </Form.Group>

                {selectedType === 'datamart' && (
                    <Form.Group className="mb-3">
                        <Form.Label>Dataset Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={datasetName}
                            onChange={(e) => setDatasetName(e.target.value)}
                            placeholder="Enter dataset name"
                        />
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-light" onClick={handleClose}>
                    Cancel
                </button>
                <button 
                    className="btn btn-primary" 
                    onClick={handleCreate}
                    disabled={isCreateDisabled}
                >
                    Create Dataset
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default NewDatasetModal;